/* erdkinder theme – header panels, product form (variants, AJAX add), cart, recommendations, addresses */
(function () {
  'use strict';
  var EK = window.erdkinder || { routes: {}, strings: {} };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* money formatting (Shopify money_format) */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '', placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || EK.moneyFormat || '€{{amount_with_comma_separator}}';
    function n(v, d) { return isNaN(v) || v == null ? 0 : v; }
    function fmt(number, precision, thousands, decimal) {
      precision = n(precision, 2); thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  /* ---------- header panels ---------- */
  function togglePanel(name, force) {
    $$('.panel').forEach(function (p) {
      var mine = p.getAttribute('data-panel') === name;
      var on = mine ? (force === undefined ? !p.classList.contains('is-open') : force) : false;
      p.classList.toggle('is-open', on);
      var btn = $('[data-toggle="' + p.getAttribute('data-panel') + '"]'); if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on && name === 'search') { var i = $('input[type=search]', p); if (i) setTimeout(function () { i.focus(); }, 30); }
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-toggle]');
    if (b) { e.preventDefault(); togglePanel(b.getAttribute('data-toggle')); return; }
    if (!e.target.closest('.site-header')) togglePanel('none', false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') togglePanel('none', false); });

  /* ---------- quantity buttons (product + cart) ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (q) { var inp = $('input', q.parentNode); inp.value = Math.max(parseInt(inp.min || '1', 10), (parseInt(inp.value, 10) || 0) + parseInt(q.getAttribute('data-qty'), 10)); inp.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  /* ---------- product page ---------- */
  var section = $('[data-product-section]');
  if (section) {
    var product = null; try { product = JSON.parse($('[data-product-json]').textContent); } catch (err) {}
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form), addLabel = $('[data-add-label]', form);
    var priceEl = $('[data-price]', section);
    var mainImg = $('#ProductMainImage', section) || $('.product__main img', section);

    function selectedOptions() {
      return $$('[data-option-index]', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function findVariant() {
      if (!product) return null;
      var opts = selectedOptions();
      if (!opts.length) return product.variants[0];
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0] || null;
    }
    function updateAvailability() {
      /* grey out option values that have no available variant given the other selections */
      if (!product) return;
      var opts = selectedOptions();
      $$('[data-option-index]', form).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var ok = product.variants.some(function (v) { return v.available && v.options.every(function (o, i) { return i === idx ? o === input.value : (test[i] == null || o === test[i]); }); });
          input.disabled = !ok && !input.checked;
        });
      });
    }
    function onChange() {
      var v = findVariant();
      updateAvailability();
      if (!v) { addBtn.disabled = true; addLabel.textContent = EK.strings.unavailable; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? EK.strings.addToCart : EK.strings.soldOut;
      if (priceEl) priceEl.innerHTML = '<span class="price' + (v.compare_at_price > v.price ? ' price--sale' : '') + '">' + formatMoney(v.price) + (v.compare_at_price > v.price ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '') + '</span>';
      if (v.featured_media && mainImg) {
        var t = $('[data-media-id="' + v.featured_media.id + '"]', section); if (t) t.click();
      }
      if (history.replaceState) { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString()); }
    }
    form.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) onChange(); });
    updateAvailability();

    /* thumbnails */
    section.addEventListener('click', function (e) {
      var th = e.target.closest('[data-thumb]');
      if (th && mainImg) { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = th.getAttribute('data-thumb'); $$('[data-thumb]', section).forEach(function (b) { b.classList.toggle('is-active', b === th); }); }
      var sg = e.target.closest('[data-sizeguide]');
      if (sg) { var d = $('[data-sizeguide-details]'); if (d) { e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
    });

    /* AJAX add to cart */
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !EK.routes.cartAdd || !document.body.classList.contains('template-product')) return;
      if (form.getAttribute('data-no-ajax') !== null) return;
      e.preventDefault();
      addBtn.disabled = true;
      var fd = new FormData(form);
      fetch(EK.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { alert(data.description || data.message); addBtn.disabled = false; return; }
          addLabel.textContent = EK.strings.added; addBtn.classList.add('is-active');
          return fetch(EK.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count || ''; el.setAttribute('data-count', cart.item_count); });
            setTimeout(function () { addLabel.textContent = EK.strings.addToCart; addBtn.classList.remove('is-active'); addBtn.disabled = false; }, 1600);
          });
        })
        .catch(function () { form.removeAttribute('data-ajax'); addBtn.disabled = false; form.submit(); });
    });
  }

  /* ---------- cart page ---------- */
  var cartSection = $('[data-cart-section]');
  if (cartSection) {
    var timer = null;
    function changeLine(line, qty) {
      if (!window.fetch || !EK.routes.cartChange) { $('#CartForm').submit(); return; }
      fetch(EK.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); });
    }
    cartSection.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-line-qty]'); if (!inp) return;
      clearTimeout(timer); timer = setTimeout(function () { changeLine(parseInt(inp.getAttribute('data-line-qty'), 10), parseInt(inp.value, 10) || 0); }, 350);
    });
    cartSection.addEventListener('click', function (e) {
      var q = e.target.closest('[data-cart-qty]');
      if (q) { var inp = $('input', q.parentNode); inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(q.getAttribute('data-cart-qty'), 10)); inp.dispatchEvent(new Event('change', { bubbles: true })); }
      var r = e.target.closest('[data-cart-remove]');
      if (r && window.fetch) { e.preventDefault(); changeLine(parseInt(r.getAttribute('data-cart-remove'), 10), 0); }
    });
  }

  /* ---------- product recommendations ---------- */
  var rec = $('[data-recommendations]');
  if (rec && window.fetch && rec.getAttribute('data-url')) {
    fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'); var inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) rec.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  /* ---------- donation counter ---------- */
  (function () {
    var els = $$('[data-counter]'); if (!els.length) return;
    var lang = (document.documentElement.lang || 'en').slice(0, 2);
    function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, lang === 'de' ? '.' : ','); }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    els.forEach(function (el) {
      var target = parseInt(el.getAttribute('data-counter'), 10) || 0;
      if (reduce || !('IntersectionObserver' in window)) { el.textContent = fmt(target); return; }
      el.textContent = fmt(0);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return; io.disconnect();
          var start = null, dur = 1400;
          function step(ts) { if (!start) start = ts; var p = Math.min(1, (ts - start) / dur); var e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(Math.round(target * e)); if (p < 1) requestAnimationFrame(step); }
          requestAnimationFrame(step);
        });
      }, { threshold: .4 });
      io.observe(el);
    });
  })();

  /* ---------- customer addresses ---------- */
  var addr = $('[data-addresses]');
  if (addr) {
    addr.addEventListener('click', function (e) {
      var t = e.target.closest('[data-address-toggle]');
      if (t) { var el = document.getElementById(t.getAttribute('data-address-toggle')); if (el) el.hidden = !el.hidden; }
      var d = e.target.closest('[data-address-delete]');
      if (d && window.confirm(d.getAttribute('data-confirm'))) {
        var f = document.createElement('form'); f.method = 'post'; f.action = d.getAttribute('data-url');
        f.innerHTML = '<input type="hidden" name="_method" value="delete">'; document.body.appendChild(f); f.submit();
      }
    });
    if (window.Shopify && Shopify.CountryProvinceSelector) {
      $$('select[name="address[country]"]', addr).forEach(function (sel) {
        var prov = sel.closest('.form__row').querySelector('select[name="address[province]"]');
        var wrap = prov ? prov.closest('.field') : null;
        if (!prov) return;
        sel.value = sel.getAttribute('data-default') || sel.value; prov.setAttribute('data-default', prov.getAttribute('data-default') || '');
        new Shopify.CountryProvinceSelector(sel.id, prov.id, { hideElement: wrap ? wrap.id || (wrap.id = prov.id + 'Wrap') : prov.id });
      });
    }
  }
  var recoverToggle = $('[data-recover-toggle]');
  if (recoverToggle) recoverToggle.addEventListener('click', function (e) { e.preventDefault(); var b = $('#RecoverBox'); b.hidden = !b.hidden; if (!b.hidden) b.scrollIntoView({ behavior: 'smooth' }); });
})();